import { Component, Inject, Injector, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule, JkDialogEditComponent, JkBaseComponent, idNameItem, jkLib } from 'jk-service';
import { SqlWhereCondition } from '../sql-where/sql-where.component';
import { qbeCompare } from '../../services/qbe.model';


@Component({
  selector: 'app-define-where',
  templateUrl: './define-where.component.html',
  styleUrls: ['./define-where.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, FormsModule, MaterialModule,]
})
export class DefineWhereComponent extends JkBaseComponent implements OnInit {

  displayedColumns: string[] = ['id', 'type1', 'label', 'dataType', 'compare', 'value', 'description'];
  readonly whereList = input<SqlWhereCondition[]>([]);
  compareList: idNameItem[] = qbeCompare;
  dataTypeList = ['number', 'string', 'date'];
  where: string = '';
  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  initDefaultList() {
    for (let i = 1; i <= 10; i++) {
      this.whereList().push({
        id: i.toString().padStart(2, '0'),
        type1: '條件',
        label: '',
        fieldName: '',
        dataType: 'string',
        compare: '=',
        value: '',
        description: ''
      });
    }
  }

  onConfirm(): void {
    // callback
    this.geneWhere();
  }

  onCancel(): void {
  }
  geneWhere(): string {
    this.where = '';
    let compare = '';
    let value = '';
    let fieldName = '';
    for (let i = 0; i < this.whereList().length; i++) {
      compare = this.whereList()[i].compare;
      value = this.whereList()[i].value;
      fieldName = this.whereList()[i].fieldName;
      const whereList = this.whereList();
      if (whereList[i].type1 === '條件') {
        if (value !== '') {
          if (whereList[i].dataType === 'string') {
            value = value.trim();
            if (compare === 'like%') {
              value = value + '%';
              this.where += ' AND ' + fieldName + ' like ' + jkLib.quotedStr(value);
            } else if (compare === '%like%') {
              value = '%' + value + '%';
              this.where += ' AND ' + fieldName + ' like ' + jkLib.quotedStr(value);
            } else if (compare === '%like') {
              value = '%' + value;
              this.where += ' AND ' + fieldName + ' like ' + jkLib.quotedStr(value);
            } else if (compare === 'IN') {
              this.where += ' AND ' + fieldName + ' ' + compare + value;
            } else {
              this.where += ' AND ' + fieldName + ' ' + compare + ' ' + jkLib.quotedStr(value);
            };
          } else
            if (whereList[i].dataType === 'number') {
              this.where += ' AND ' + fieldName + ' ' + compare + ' ' + value;
            } else {// date
              this.where += ' AND ' + fieldName + ' ' + compare + ' ' + value;
            }
        }
      }
    }
    return this.where;
  }

  replaceParameter(where: string): string {
    let result = where;
    for (let i = 0; i < this.whereList().length; i++) {
      let value = this.whereList()[i].value;
      const whereList = this.whereList();
      if (whereList[i].type1 === '參數') {
        if (value.trim() === '') {
          alert('請輸入參數值');
          throw new Error('請輸入參數值');
        };
        if (whereList[i].compare === 'IN') {
          result = result.replace(whereList[i].fieldName, value);
        } else if (whereList[i].dataType === 'string') {
          result = result.replace(whereList[i].fieldName, jkLib.quotedStr(value));
        } else if (whereList[i].dataType === 'number') {
          result = result.replace(whereList[i].fieldName, whereList[i].value);
        }
      }
    }
    return result;
  }
}
